export type ExpoVisitorHeaderConfig = {
  title?: string;
  description?: string;
};

export function getExpoVisitorRouteHeader(pathname: string): ExpoVisitorHeaderConfig {
  if (pathname === "/expos") {
    return {
      title: "Expos",
      description: "Browse live, upcoming, and past expos.",
    };
  }
  if (pathname === "/shortlist") {
    return {
      title: "Shortlist",
      description: "Companies shortlisted by you are visible here.",
    };
  }
  if (pathname === "/updates") {
    return {
      title: "Updates",
      description: "All your in-app notifications in one place.",
    };
  }
  if (pathname === "/settings") {
    return { title: "Settings" };
  }
  if (pathname === "/account") {
    return {
      title: "My Profile",
      description: "The details you submitted when you signed up.",
    };
  }
  return {};
}
